import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "dining-table-for-6",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "dining table for 6",
    description: "bathroom-sink",
    image: require("./dining-table-for-6.svg"),
    svgIcon: require("./dining-table-for-6.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 40) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M11.56,73.36l-.29-.19a1.15,1.15,0,0,1-.66-1.12,1.21,1.21,0,0,1,.9-1,4.36,4.36,0,0,1,.78-.13l-.51-2.49H.76c-.65,0-.76-.11-.76-.74V27.9c0-.62.11-.74.72-.74H11.79l.51-2.33-.55-.07a1.3,1.3,0,0,1-1.15-1.18,1.28,1.28,0,0,1,1.15-1.16,3.68,3.68,0,0,1,.66-.06H29a4.27,4.27,0,0,1,.71.07,1.28,1.28,0,0,1,1.06,1.15,1.3,1.3,0,0,1-1.11,1.17c-.21,0-.43.05-.6.07l.53,2.31H40.4l.5-2.3-.5-.06a1.3,1.3,0,0,1-1.18-1.19,1.27,1.27,0,0,1,1.19-1.17,3.07,3.07,0,0,1,.53-.05H57.66a3.34,3.34,0,0,1,.7.08,1.16,1.16,0,0,1,0,2.3,6.37,6.37,0,0,1-.69.08l.54,2.31H69l.53-2.29a6.5,6.5,0,0,1-.82-.16,1.13,1.13,0,0,1-.86-1.11,1.15,1.15,0,0,1,.89-1.09,2.87,2.87,0,0,1,.83-.11H86.27a3.18,3.18,0,0,1,.62.06,1.17,1.17,0,0,1,0,2.33,6.07,6.07,0,0,1-.61.08l.53,2.33h11c.66,0,.77.11.77.78v39.7c0,.66-.12.78-.77.78h-11L86.3,70.9a4.46,4.46,0,0,1,.84.17,1.12,1.12,0,0,1,.14,2.11l-.3.18H68.83a1.2,1.2,0,0,0-.21-.13,1.15,1.15,0,0,1-.78-1.18,1.19,1.19,0,0,1,.93-1,3.89,3.89,0,0,1,.74-.12L69,68.45H58.79l-.51,2.45a4.78,4.78,0,0,1,.8.15,1.15,1.15,0,0,1,.86,1,1.1,1.1,0,0,1-.68,1.15c-.1,0-.2.12-.3.18H40.82l-.38-.22a1.08,1.08,0,0,1-.63-1,1.07,1.07,0,0,1,.7-1,5.35,5.35,0,0,1,1-.25L41,68.46H29.58l-.5,2.4a5.51,5.51,0,0,1,1.13.37,1.06,1.06,0,0,1,0,1.87c-.16.1-.34.17-.51.26ZM97.9,27.73H.72V67.85H97.9ZM28.8,68.45H12.52a9.29,9.29,0,0,0,.21,1.47c.26.91.45,1,1.36,1h13.6a.68.68,0,0,0,.65-.34A3.67,3.67,0,0,0,28.8,68.45Zm40.89,0c.14.67.22,1.27.39,1.84a.87.87,0,0,0,1,.67c1.87,0,3.73,0,5.6,0h8.27c.16,0,.39,0,.47-.14A3,3,0,0,0,86,68.44ZM58,68.45H41.81a3,3,0,0,0,.49,2.24.68.68,0,0,0,.46.23c.62,0,1.25,0,1.87,0H56.9a.64.64,0,0,0,.62-.31A3.41,3.41,0,0,0,58,68.45ZM28.8,27.14a3.39,3.39,0,0,0-.48-2,.66.66,0,0,0-.62-.32h-14a.55.55,0,0,0-.6.34,12.52,12.52,0,0,0-.46,1.47c-.11.51-.05.55.47.55H28.31Zm28.56,0a3.06,3.06,0,0,0-.41-2,.67.67,0,0,0-.66-.34H42.34c-.18,0-.43,0-.53.12a2.89,2.89,0,0,0-.61,2.21Zm28.74,0a14,14,0,0,0-.38-1.66c-.1-.3-.24-.68-.7-.68H70.8a.53.53,0,0,0-.36.1,2.68,2.68,0,0,0-.6,2.23Zm-8.19-2.87H86a1.6,1.6,0,0,0,.7-.06,1.17,1.17,0,0,0,.54-.61c.06-.31-.2-.55-.52-.63a3.17,3.17,0,0,0-.61-.07H69.67a1.2,1.2,0,0,0-.61.08c-.23.15-.5.38-.54.61s.23.56.56.63a2.89,2.89,0,0,0,.66.05Zm-28.64,0h8.22a1.85,1.85,0,0,0,.78-.12.74.74,0,0,0,.39-.52.83.83,0,0,0-.38-.58,1.41,1.41,0,0,0-.72-.15H41a2.33,2.33,0,0,0-.53.06c-.33.07-.6.24-.59.62a.66.66,0,0,0,.65.66c.2,0,.41,0,.62,0Zm-28.6-1.38c-2.74,0-5.48,0-8.22,0a2,2,0,0,0-.81.17.56.56,0,0,0,0,1.05,2,2,0,0,0,.81.15H28.9a2.47,2.47,0,0,0,.61-.05.62.62,0,0,0,.55-.61.6.6,0,0,0-.51-.63,2.32,2.32,0,0,0-.65-.08Zm0,49.93h8.27a3.2,3.2,0,0,0,.44,0c.37,0,.66-.21.68-.63s-.28-.59-.63-.68a2,2,0,0,0-.35,0H12.28a1.46,1.46,0,0,0-.68.17.55.55,0,0,0,0,1,1.46,1.46,0,0,0,.71.17C15.1,72.83,17.89,72.82,20.67,72.82Zm57.24,0h8.44c.55,0,1-.29,1-.66s-.39-.67-1-.69H69.56a1,1,0,0,0-.6.1,1,1,0,0,0-.44.59c0,.19.23.44.43.56a1.33,1.33,0,0,0,.64.09Zm-28,0h8.36c.66,0,1.07-.27,1.06-.68s-.4-.67-1-.67H41.52a1,1,0,0,0-.56.09c-.2.14-.46.39-.45.57s.27.46.48.61.37.07.56.07Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M29.7,73.36c.17-.09.35-.16.51-.26a1.06,1.06,0,0,0,0-1.87,5.51,5.51,0,0,0-1.13-.37l.5-2.4H41l.51,2.43a5.35,5.35,0,0,0-1,.25,1.07,1.07,0,0,0-.7,1,1.08,1.08,0,0,0,.63,1l.38.22Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M59,73.36c.1-.06.2-.13.3-.18A1.1,1.1,0,0,0,59.94,72a1.15,1.15,0,0,0-.86-1,4.78,4.78,0,0,0-.8-.15l.51-2.45H69l.53,2.46a3.89,3.89,0,0,0-.74.12,1.19,1.19,0,0,0-.93,1,1.15,1.15,0,0,0,.78,1.18,1.2,1.2,0,0,1,.21.13Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M97.9,27.73V67.85H.72V27.73ZM20.74,57a6.48,6.48,0,0,0-4,1.19,3.83,3.83,0,0,0-.32,6.17,6.32,6.32,0,0,0,8.39-.27A3.69,3.69,0,0,0,25,58.87,5.61,5.61,0,0,0,20.74,57ZM20.2,29.94a5.67,5.67,0,0,0-3.88,1.54A3.75,3.75,0,0,0,16.13,37a6.32,6.32,0,0,0,8.42.29,3.79,3.79,0,0,0-.13-6A6.18,6.18,0,0,0,20.2,29.94Zm29.5,0a6.41,6.41,0,0,0-4.44,1.43A3.76,3.76,0,0,0,44.9,37a6.3,6.3,0,0,0,8.9-.12,3.7,3.7,0,0,0-.06-5.06A5.58,5.58,0,0,0,49.7,29.93ZM78,57a6.06,6.06,0,0,0-3.69,1.2A3.8,3.8,0,0,0,73.64,64a6.28,6.28,0,0,0,9.1-.22,3.66,3.66,0,0,0,0-4.62A5.71,5.71,0,0,0,78,57ZM49.93,57a6,6,0,0,0-3.61,1.2,3.83,3.83,0,0,0-.44,6,6.39,6.39,0,0,0,8,.33,3.83,3.83,0,0,0,.14-6.18A6,6,0,0,0,49.93,57ZM78.11,29.93a6,6,0,0,0-3.91,1.32,3.79,3.79,0,0,0-.2,6,6.36,6.36,0,0,0,8.17,0,3.74,3.74,0,0,0,.18-5.69A5.79,5.79,0,0,0,78.11,29.93ZM29.57,58.19a8.14,8.14,0,0,0,.86-.14,1.73,1.73,0,0,0,1.33-1.49A1.63,1.63,0,0,0,30.53,55a2.44,2.44,0,0,0-2,.14,1.52,1.52,0,0,0-.92,1.36,1.45,1.45,0,0,0,.87,1.39A6.31,6.31,0,0,0,29.57,58.19ZM87.32,40.94a4.87,4.87,0,0,0,.66-.09,1.59,1.59,0,0,0,1.08-2.5,2.36,2.36,0,0,0-3.58.11,1.33,1.33,0,0,0,0,1.51A2.16,2.16,0,0,0,87.32,40.94Zm0,13.75a8.29,8.29,0,0,0-1.41.57,1.43,1.43,0,0,0-.06,2.41,2.43,2.43,0,0,0,2.89,0,1.42,1.42,0,0,0-.06-2.43A7.72,7.72,0,0,0,87.32,54.69Zm-28.1,3.56a2.9,2.9,0,0,0,1.59-.64,1.42,1.42,0,0,0,0-2.22A2.4,2.4,0,0,0,58,55.17a1.46,1.46,0,0,0,0,2.59A6.5,6.5,0,0,0,59.22,58.25Zm-.68-20.77a2.69,2.69,0,0,0-1.8.89,1.44,1.44,0,0,0,.11,1.91,2.43,2.43,0,0,0,3,.23,1.44,1.44,0,0,0,0-2.49A7.87,7.87,0,0,0,58.54,37.48Zm-28.83,0a7,7,0,0,0-1.13.34,1.49,1.49,0,0,0-.39,2.56,2.4,2.4,0,0,0,3.06,0,1.41,1.41,0,0,0,0-2.19A2.69,2.69,0,0,0,29.71,37.51ZM27,37.38l.1.11c.07-.09.19-.16.21-.26a1.62,1.62,0,0,0,0-.44V31.25c0-.19.07-.46-.32-.36Zm57.78-6.55-.14.07a.19.19,0,0,0,0,.08c0,2.07,0,4.13,0,6.2,0,.09.09.18.14.26.06-.09.17-.19.18-.29q0-3,0-6C84.9,31.06,84.8,30.94,84.75,30.83Zm-42.16,0-.14.07a.41.41,0,0,0,0,.08v6.21c0,.08.1.17.15.25.06-.09.17-.19.17-.29q0-3,0-6C42.74,31.05,42.64,30.94,42.59,30.83Zm13.22.05a.26.26,0,0,0,0,.1c0,2.07,0,4.14,0,6.21,0,.08.1.17.15.25.06-.09.17-.19.17-.28,0-.47,0-.93,0-1.39V31.25C56.1,31.06,56.16,30.8,55.81,30.88Zm-42.16,0s0,.07,0,.09v6.22c0,.08.1.17.15.25.06-.09.17-.19.18-.28,0-.47,0-.93,0-1.39,0-1.51,0-3,0-4.52C13.94,31.06,14,30.8,13.65,30.88Zm0,27.46v6.5l.13.06a1.09,1.09,0,0,0,.18-.31c0-.25,0-.5,0-.76,0-1.71,0-3.42,0-5.13C13.94,58.5,14,58.23,13.63,58.34Zm13.32,0v6.29c0,.07.1.15.14.22s.19-.15.19-.22c0-.38,0-.75,0-1.12V58.69C27.29,58.49,27.35,58.22,27,58.35Zm29.6,6.48.16.06c0-.11.16-.23.16-.34,0-.72,0-1.43,0-2.15,0-1.25,0-2.5,0-3.76,0-.11-.11-.22-.17-.33a1.73,1.73,0,0,0-.14.31.81.81,0,0,0,0,.27v5.94Zm28,0,.17.07a1.33,1.33,0,0,0,.14-.41c0-1.12,0-2.23,0-3.35,0-.83,0-1.67,0-2.5,0-.11-.11-.22-.17-.33l-.13.06Zm1.09-5.9-.1.08v5.17l.1.08c.07-.09.21-.18.21-.27,0-1.6,0-3.2,0-4.79C85.89,59.1,85.76,59,85.68,58.92ZM28.12,64.26l.16-.09c0-1.67,0-3.33,0-5,0-.08-.12-.15-.18-.22s-.15.17-.15.26c0,1.57,0,3.15,0,4.72C27.94,64.05,28.05,64.15,28.12,64.26Zm29.42-.08.16.06c.06-.12.17-.24.17-.36,0-1.54,0-3.08,0-4.61,0-.11-.12-.21-.18-.31,0,.1-.14.2-.14.31,0,1,0,2,0,3Zm28-27.44.12.07c.06-.1.19-.19.19-.29q0-2.37,0-4.74c0-.09-.13-.19-.2-.28l-.11.07Zm-28.84,0,.15.11c.07-.09.19-.19.19-.29q0-2.37,0-4.74c0-.08-.11-.16-.17-.24,0,.08-.16.16-.16.25C56.74,33.43,56.74,35.07,56.74,36.7ZM28.26,31.57l-.11-.07c-.08.09-.21.18-.21.28q0,2.37,0,4.74c0,.1.13.2.2.29l.12-.06Zm43,2.58c0,1,0,1.94,0,2.91a1.11,1.11,0,0,0,.16.38,1.38,1.38,0,0,0,.15-.36V31.23a1.38,1.38,0,0,0-.15-.36,1,1,0,0,0-.16.38C71.22,32.22,71.22,33.19,71.22,34.15ZM43.52,61.58c0-1,0-1.93,0-2.9,0-.12-.11-.24-.17-.37a1.17,1.17,0,0,0-.13.37c0,1.94,0,3.87,0,5.8a1.14,1.14,0,0,0,.13.38c.06-.13.17-.25.17-.38C43.53,63.52,43.52,62.55,43.52,61.58Zm27.7,0c0,1,0,2,0,3a.91.91,0,0,0,.13.33c.06-.11.17-.22.17-.33,0-2,0-3.93,0-5.89,0-.11-.11-.22-.17-.33a.91.91,0,0,0-.13.33C71.22,59.61,71.22,60.57,71.22,61.54Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M28.8,68.45a3.67,3.67,0,0,1-.46,2.15.68.68,0,0,1-.65.34H14.09c-.91,0-1.1-.11-1.36-1a9.29,9.29,0,0,1-.21-1.47Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M69.69,68.44H86a3,3,0,0,1-.57,2.35c-.08.11-.31.14-.47.14H76.66c-1.87,0-3.73,0-5.6,0a.87.87,0,0,1-1-.67C69.91,69.71,69.83,69.11,69.69,68.44Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M58,68.45a3.41,3.41,0,0,1-.45,2.18.64.64,0,0,1-.62.31H44.63c-.62,0-1.25,0-1.87,0a.68.68,0,0,1-.46-.23,3,3,0,0,1-.49-2.24Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M28.8,27.14l-.49,0H13.06c-.52,0-.58,0-.47-.55a12.52,12.52,0,0,1,.46-1.47.55.55,0,0,1,.6-.34H27.7a.66.66,0,0,1,.62.32A3.39,3.39,0,0,1,28.8,27.14Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M57.36,27.14H41.2a2.89,2.89,0,0,1,.61-2.21c.1-.11.35-.12.53-.12H56.29a.67.67,0,0,1,.66.34A3.06,3.06,0,0,1,57.36,27.14Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M86.1,27.14H69.84a2.68,2.68,0,0,1,.6-2.23.53.53,0,0,1,.36-.1H85c.46,0,.6.38.7.68A14,14,0,0,1,86.1,27.14Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M77.91,24.27H69.74a2.89,2.89,0,0,1-.66-.05c-.33-.07-.63-.29-.56-.63s.31-.46.54-.61a1.2,1.2,0,0,1,.61-.08H86.15a3.17,3.17,0,0,1,.61.07c.32.08.58.32.52.63a1.17,1.17,0,0,1-.54.61,1.6,1.6,0,0,1-.7.06Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M49.27,24.27H41.18c-.21,0-.42,0-.62,0a.66.66,0,0,1-.65-.66c0-.38.26-.55.59-.62a2.33,2.33,0,0,1,.53-.06H57.56a1.41,1.41,0,0,1,.72.15.83.83,0,0,1,.38.58.74.74,0,0,1-.39.52,1.85,1.85,0,0,1-.78.12Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M20.67,22.89H28.9a2.32,2.32,0,0,1,.65.08.6.6,0,0,1,.51.63.62.62,0,0,1-.55.61,2.47,2.47,0,0,1-.61.05H12.45a2,2,0,0,1-.81-.15.56.56,0,0,1,0-1.05,2,2,0,0,1,.81-.17C15.19,22.88,17.93,22.89,20.67,22.89Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M20.67,72.82c-2.78,0-5.57,0-8.36,0a1.46,1.46,0,0,1-.71-.17.55.55,0,0,1,0-1,1.46,1.46,0,0,1,.68-.17h16.8a2,2,0,0,1,.35,0c.35.09.66.25.63.68s-.31.58-.68.63a3.2,3.2,0,0,1-.44,0Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M77.91,72.82H69.59a1.33,1.33,0,0,1-.64-.09c-.2-.12-.44-.37-.43-.56a1,1,0,0,1,.44-.59,1,1,0,0,1,.6-.1h16.8c.56,0,1,.3,1,.69s-.41.66-1,.66Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M49.86,72.82H41.55c-.19,0-.43,0-.56-.07s-.46-.39-.48-.61.25-.43.45-.57a1,1,0,0,1,.56-.09H58.24c.64,0,1,.25,1,.67s-.4.68-1.06.68Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M20.74,57A5.61,5.61,0,0,1,25,58.87a3.69,3.69,0,0,1-.13,5.22,6.32,6.32,0,0,1-8.39.27,3.83,3.83,0,0,1,.32-6.17A6.48,6.48,0,0,1,20.74,57Zm-.5.29A5.72,5.72,0,0,0,17,58.38a3.59,3.59,0,0,0-.15,5.95,6.06,6.06,0,0,0,7.23,0,3.55,3.55,0,0,0,.5-5.42A5.56,5.56,0,0,0,20.24,57.29Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M20.2,29.94a6.18,6.18,0,0,1,4.22,1.34,3.79,3.79,0,0,1,.13,6A6.32,6.32,0,0,1,16.13,37a3.75,3.75,0,0,1,.19-5.51A5.67,5.67,0,0,1,20.2,29.94Zm.2.27a5.74,5.74,0,0,0-3.52,1.18A3.58,3.58,0,0,0,16.6,37a6,6,0,0,0,7.58.18,3.6,3.6,0,0,0-.28-5.95A5.88,5.88,0,0,0,20.4,30.21Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M49.7,29.93a5.58,5.58,0,0,1,4,1.85,3.7,3.7,0,0,1,.06,5.06,6.3,6.3,0,0,1-8.9.12,3.76,3.76,0,0,1,.36-5.6A6.41,6.41,0,0,1,49.7,29.93Zm-.18,8.53a5.62,5.62,0,0,0,3.37-1.18A3.57,3.57,0,0,0,53,31.49a6,6,0,0,0-7.37,0,3.55,3.55,0,0,0-.08,5.7A5.85,5.85,0,0,0,49.52,38.46Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M78,57a5.71,5.71,0,0,1,4.73,2.13,3.66,3.66,0,0,1,0,4.62,6.28,6.28,0,0,1-9.1.22,3.8,3.8,0,0,1,.71-5.77A6.06,6.06,0,0,1,78,57Zm5.2,4.29A3.57,3.57,0,0,0,82,58.71a6,6,0,0,0-7.51-.23,3.55,3.55,0,0,0-.32,5.58,6,6,0,0,0,7.74.13A3.77,3.77,0,0,0,83.24,61.29Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M49.93,57a6,6,0,0,1,4.12,1.37,3.83,3.83,0,0,1-.14,6.18,6.39,6.39,0,0,1-8-.33,3.83,3.83,0,0,1,.44-6A6,6,0,0,1,49.93,57Zm.12.27a5.83,5.83,0,0,0-3.49,1.12,3.57,3.57,0,0,0-.5,5.57,6,6,0,0,0,7.79.24,3.57,3.57,0,0,0-.16-5.74A5.84,5.84,0,0,0,50.05,57.28Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M78.11,29.93a5.79,5.79,0,0,1,4.24,1.65,3.74,3.74,0,0,1-.18,5.69,6.36,6.36,0,0,1-8.17,0,3.79,3.79,0,0,1,.2-6A6,6,0,0,1,78.11,29.93Zm-.49,8.52a6.06,6.06,0,0,0,4.11-1.2,3.52,3.52,0,0,0,.5-5.35,5,5,0,0,0-2.82-1.55,5.69,5.69,0,0,0-5.5,1.6,3.44,3.44,0,0,0-.17,4.57A5.18,5.18,0,0,0,77.62,38.45Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M29.57,58.19a6.31,6.31,0,0,1-1.07-.35,1.45,1.45,0,0,1-.87-1.39,1.52,1.52,0,0,1,.92-1.36,2.44,2.44,0,0,1,2-.14,1.63,1.63,0,0,1,1.23,1.61,1.73,1.73,0,0,1-1.33,1.49A8.14,8.14,0,0,1,29.57,58.19Zm.16-.31a3.28,3.28,0,0,0,.39,0,1.57,1.57,0,0,0,1.25-1A1.15,1.15,0,0,0,31,55.58a1.93,1.93,0,0,0-1.33-.5,1.62,1.62,0,0,0-1.75,1.42A1.64,1.64,0,0,0,29.73,57.88Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M87.32,40.94a2.16,2.16,0,0,1-1.89-1,1.33,1.33,0,0,1,0-1.51,2.36,2.36,0,0,1,3.58-.11A1.59,1.59,0,0,1,88,40.85,4.87,4.87,0,0,1,87.32,40.94Zm1.82-1.69a4.55,4.55,0,0,0-.46-.83,2,2,0,0,0-2.45-.26,1.24,1.24,0,0,0,0,2.21,2,2,0,0,0,2.44-.29A4,4,0,0,0,89.14,39.25Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M87.32,54.69a7.72,7.72,0,0,1,1.36.57,1.42,1.42,0,0,1,.06,2.43,2.43,2.43,0,0,1-2.89,0,1.43,1.43,0,0,1,.06-2.41A8.29,8.29,0,0,1,87.32,54.69Zm0,3.29a5.83,5.83,0,0,0,1.2-.5,1.15,1.15,0,0,0,0-1.95,2.57,2.57,0,0,0-1.27-.43,1.55,1.55,0,0,0-1.71,1.38A1.76,1.76,0,0,0,87.3,58Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M59.22,58.25A6.5,6.5,0,0,1,58,57.76a1.46,1.46,0,0,1,0-2.59,2.4,2.4,0,0,1,2.84.22,1.42,1.42,0,0,1,0,2.22A2.9,2.9,0,0,1,59.22,58.25Zm.07-3.17a1.82,1.82,0,0,0-1.43.6,1.18,1.18,0,0,0,0,1.65,2,2,0,0,0,2.69.06,1.52,1.52,0,0,0,.41-.84C61.07,55.72,60.29,55.08,59.29,55.08Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M58.54,37.48a7.87,7.87,0,0,1,1.33.54,1.44,1.44,0,0,1,0,2.49,2.43,2.43,0,0,1-3-.23,1.44,1.44,0,0,1-.11-1.91A2.69,2.69,0,0,1,58.54,37.48Zm1.74,1.68a3,3,0,0,0-.41-.73,2,2,0,0,0-2.69-.09,1.19,1.19,0,0,0-.33,1.38,1.7,1.7,0,0,0,1.64.94,1.68,1.68,0,0,0,1.64-.93A3.72,3.72,0,0,0,60.28,39.16Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M29.71,37.51a2.69,2.69,0,0,1,1.55.66,1.41,1.41,0,0,1,0,2.19,2.4,2.4,0,0,1-3.06,0,1.49,1.49,0,0,1,.39-2.56A7,7,0,0,1,29.71,37.51Zm0,3.28A7.24,7.24,0,0,0,31,40.17a1.16,1.16,0,0,0,.14-1.7,2,2,0,0,0-2.88,0,1.17,1.17,0,0,0,.18,1.73A8,8,0,0,0,29.71,40.79Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M27,37.38V30.89c.39-.1.32.17.32.36v5.54a1.62,1.62,0,0,1,0,.44c0,.1-.14.17-.21.26Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M84.75,30.83c0,.11.15.23.15.34q0,3,0,6c0,.1-.12.2-.18.29,0-.08-.14-.17-.14-.26,0-2.07,0-4.13,0-6.2a.19.19,0,0,1,0-.08Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M42.59,30.83c0,.11.15.22.15.34q0,3,0,6c0,.1-.11.2-.17.29,0-.08-.15-.17-.15-.25V31a.41.41,0,0,1,0-.08Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M55.81,30.88c.35-.08.29.18.29.37v4.52c0,.46,0,.92,0,1.39,0,.09-.11.19-.17.28-.05-.08-.15-.17-.15-.25,0-2.07,0-4.14,0-6.21A.26.26,0,0,1,55.81,30.88Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M13.65,30.88c.35-.08.29.18.29.37,0,1.51,0,3,0,4.52,0,.46,0,.92,0,1.39,0,.09-.12.19-.18.28,0-.08-.15-.17-.15-.25V31S13.64,30.92,13.65,30.88Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M13.63,58.34c.38-.11.31.16.31.36,0,1.71,0,3.42,0,5.13,0,.26,0,.51,0,.76a1.09,1.09,0,0,1-.18.31l-.13-.06Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M27,58.35c.4-.13.34.14.34.34v4.83c0,.37,0,.74,0,1.12,0,.07-.12.15-.19.22s-.13-.15-.14-.22Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M56.55,64.83V58.89a.81.81,0,0,1,0-.27,1.73,1.73,0,0,1,.14-.31c.06.11.17.22.17.33,0,1.26,0,2.51,0,3.76,0,.72,0,1.43,0,2.15,0,.11-.11.23-.16.34Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M84.59,64.82V58.36l.13-.06c.06.11.17.22.17.33,0,.83,0,1.67,0,2.5,0,1.12,0,2.23,0,3.35a1.33,1.33,0,0,1-.14.41Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M85.68,58.92c.08.09.21.18.21.27,0,1.59,0,3.19,0,4.79,0,.09-.14.18-.21.27l-.1-.08V59Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M28.12,64.26c-.07-.11-.18-.21-.18-.32,0-1.57,0-3.15,0-4.72,0-.09.1-.18.15-.26s.18.14.18.22c0,1.66,0,3.32,0,5Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M57.54,64.18V62.27c0-1,0-2,0-3,0-.11.09-.21.14-.31.06.1.18.2.18.31,0,1.53,0,3.07,0,4.61,0,.12-.11.24-.17.36Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M85.58,36.74V31.57l.11-.07c.07.09.2.19.2.28q0,2.37,0,4.74c0,.1-.13.19-.19.29Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M56.74,36.7c0-1.63,0-3.27,0-4.91,0-.09.11-.17.16-.25.06.08.17.16.17.24q0,2.37,0,4.74c0,.1-.12.2-.19.29Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M28.26,31.57v5.18l-.12.06c-.07-.09-.2-.19-.2-.29q0-2.37,0-4.74c0-.1.13-.19.21-.28Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M71.22,34.15c0-1,0-1.93,0-2.9a1,1,0,0,1,.16-.38,1.38,1.38,0,0,1,.15.36v5.85a1.38,1.38,0,0,1-.15.36,1.11,1.11,0,0,1-.16-.38C71.22,36.09,71.22,35.12,71.22,34.15Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M43.52,61.58c0,1,0,1.94,0,2.9,0,.13-.11.25-.17.38a1.14,1.14,0,0,1-.13-.38c0-1.93,0-3.86,0-5.8a1.17,1.17,0,0,1,.13-.37c.06.13.17.25.17.37C43.53,59.65,43.52,60.62,43.52,61.58Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M71.22,61.54c0-1,0-1.93,0-2.9a.91.91,0,0,1,.13-.33c.06.11.17.22.17.33,0,2,0,3.92,0,5.89,0,.11-.11.22-.17.33a.91.91,0,0,1-.13-.33C71.22,63.53,71.22,62.54,71.22,61.54Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M20.24,57.29a5.56,5.56,0,0,1,4.35,1.64,3.55,3.55,0,0,1-.5,5.42,6.06,6.06,0,0,1-7.23,0A3.59,3.59,0,0,1,17,58.38,5.72,5.72,0,0,1,20.24,57.29ZM20.51,65a3.06,3.06,0,0,0,.29-.18c1.3-1,2.59-2.09,3.89-3.12.26-.21.26-.36,0-.55-1.29-1-2.58-2.06-3.85-3.1a.47.47,0,0,0-.67,0l-3.85,3.1c-.26.21-.24.34,0,.54l3.85,3.1A3.53,3.53,0,0,0,20.51,65Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M20.4,30.21a5.88,5.88,0,0,1,3.5,1.05,3.6,3.6,0,0,1,.28,5.95A6,6,0,0,1,16.6,37a3.58,3.58,0,0,1,.28-5.64A5.74,5.74,0,0,1,20.4,30.21Zm-4.31,4.13a.76.76,0,0,0,.08.16c1.37,1.1,2.72,2.21,4.1,3.29a.65.65,0,0,0,.57-.06c1.28-1,2.54-2,3.82-3.06.31-.24.27-.39,0-.61-1.26-1-2.53-2-3.78-3a.49.49,0,0,0-.73,0L16.71,33.8Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M49.52,38.46a5.85,5.85,0,0,1-4-1.31,3.55,3.55,0,0,1,.08-5.7,6,6,0,0,1,7.37,0,3.57,3.57,0,0,1-.11,5.79A5.62,5.62,0,0,1,49.52,38.46Zm4.22-4.08a1.69,1.69,0,0,0-.2-.24L49.63,31A.41.41,0,0,0,49,31q-1.95,1.59-3.92,3.15c-.21.17-.25.3,0,.49,1.32,1,2.63,2.12,4,3.16a.53.53,0,0,0,.52,0c1.32-1,2.62-2.09,3.93-3.14A2.73,2.73,0,0,0,53.74,34.38Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M83.24,61.29a3.77,3.77,0,0,1-1.34,2.9,6,6,0,0,1-7.74-.13,3.55,3.55,0,0,1,.32-5.58,6,6,0,0,1,7.51.23A3.57,3.57,0,0,1,83.24,61.29Zm-.62.17a2.11,2.11,0,0,0-.28-.32C81,60.08,79.75,59,78.43,58a.6.6,0,0,0-.58,0c-1.32,1-2.62,2.08-3.92,3.13-.22.17-.27.32,0,.52q2,1.54,3.88,3.12a.42.42,0,0,0,.62,0l3.91-3.16A1.57,1.57,0,0,1,82.62,61.46Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M50.05,57.28a5.84,5.84,0,0,1,3.64,1.19,3.57,3.57,0,0,1,.16,5.74A6,6,0,0,1,46.06,64a3.57,3.57,0,0,1,.5-5.57A5.83,5.83,0,0,1,50.05,57.28Zm0,.51-.74.58L46,61.07c-.2.16-.38.3-.07.55,1.32,1,2.62,2.1,3.94,3.14a.57.57,0,0,0,.52,0c1.34-1.05,2.65-2.12,4-3.18.21-.17.23-.3,0-.48C53,60.08,51.71,59,50.4,58A3.2,3.2,0,0,0,50.06,57.79Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M77.62,38.45a5.18,5.18,0,0,1-3.88-1.93A3.44,3.44,0,0,1,73.91,32a5.69,5.69,0,0,1,5.5-1.6,5,5,0,0,1,2.82,1.55,3.52,3.52,0,0,1-.5,5.35A6.06,6.06,0,0,1,77.62,38.45Zm4.94-4a1.47,1.47,0,0,0-.18-.24c-1.33-1.08-2.65-2.15-4-3.2a.61.61,0,0,0-.57,0c-1.28,1-2.54,2-3.82,3.05-.33.26-.28.4,0,.64q1.86,1.47,3.71,3a.53.53,0,0,0,.8,0c1.14-.94,2.28-1.85,3.43-2.78Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M29.73,57.88a1.64,1.64,0,0,1-1.79-1.38,1.62,1.62,0,0,1,1.75-1.42,1.93,1.93,0,0,1,1.33.5,1.15,1.15,0,0,1,.35,1.26,1.57,1.57,0,0,1-1.25,1A3.28,3.28,0,0,1,29.73,57.88Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M89.14,39.25a4,4,0,0,1-.45.83,2,2,0,0,1-2.44.29,1.24,1.24,0,0,1,0-2.21,2,2,0,0,1,2.45.26A4.55,4.55,0,0,1,89.14,39.25Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M87.3,58a1.76,1.76,0,0,1-1.74-1.5,1.55,1.55,0,0,1,1.71-1.38,2.57,2.57,0,0,1,1.27.43,1.15,1.15,0,0,1,0,1.95A5.83,5.83,0,0,1,87.3,58Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M59.29,55.08c1,0,1.78.64,1.71,1.47a1.52,1.52,0,0,1-.41.84,2,2,0,0,1-2.69-.06,1.18,1.18,0,0,1,0-1.65A1.82,1.82,0,0,1,59.29,55.08Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M60.28,39.16a3.72,3.72,0,0,1-.15.57,1.68,1.68,0,0,1-1.64.93,1.7,1.7,0,0,1-1.64-.94,1.19,1.19,0,0,1,.33-1.38,2,2,0,0,1,2.69.09A3,3,0,0,1,60.28,39.16Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M29.71,40.79a8,8,0,0,1-1.28-.58,1.17,1.17,0,0,1-.18-1.73,2,2,0,0,1,2.88,0,1.16,1.16,0,0,1-.14,1.7A7.24,7.24,0,0,1,29.71,40.79Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M20.51,65a3.53,3.53,0,0,1-.32-.21l-3.85-3.1c-.25-.2-.27-.33,0-.54L20.18,58a.47.47,0,0,1,.67,0c1.27,1,2.56,2.07,3.85,3.1.25.19.25.34,0,.55-1.3,1-2.59,2.08-3.89,3.12A3.06,3.06,0,0,1,20.51,65Zm0-.34,4-3.24-4-3.24-4,3.24Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M16.09,34.34l.62-.54L20.14,31a.49.49,0,0,1,.73,0c1.25,1,2.52,2,3.78,3,.28.22.32.37,0,.61-1.28,1-2.54,2-3.82,3.06a.65.65,0,0,1-.57.06c-1.38-1.08-2.73-2.19-4.1-3.29A.76.76,0,0,1,16.09,34.34Zm8.45,0-4-3.24-4,3.22a3.21,3.21,0,0,0,.29.27c.89.72,1.77,1.44,2.67,2.15.34.28.7.75,1.05.74s.71-.47,1.06-.75Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M53.74,34.38a2.73,2.73,0,0,1-.22.24c-1.31,1.05-2.61,2.11-3.93,3.14a.53.53,0,0,1-.52,0c-1.33-1-2.64-2.11-4-3.16-.24-.19-.2-.32,0-.49q2-1.56,3.92-3.15a.41.41,0,0,1,.59,0l3.91,3.16A1.69,1.69,0,0,1,53.74,34.38Zm-8.45,0,4,3.25,4-3.25-4-3.25Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M82.62,61.46a1.57,1.57,0,0,0-.29.15l-3.91,3.16a.42.42,0,0,1-.62,0q-1.93-1.57-3.88-3.12c-.26-.2-.21-.35,0-.52,1.3-1,2.6-2.1,3.92-3.13a.6.6,0,0,1,.58,0c1.32,1,2.61,2.09,3.91,3.15A2.11,2.11,0,0,1,82.62,61.46Zm-4.5-3.34-4,3.25,4,3.25,4-3.25Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M50.06,57.79a3.2,3.2,0,0,1,.34.19c1.31,1,2.61,2.1,3.92,3.15.23.18.21.31,0,.48-1.32,1.06-2.63,2.13-4,3.18a.57.57,0,0,1-.52,0c-1.32-1-2.62-2.1-3.94-3.14-.31-.25-.13-.39.07-.55l3.36-2.7Zm4.08,3.58-4-3.24-4,3.24,4,3.24Z"
              transform="translate(0 -22.36)"
            />
            <path
              d="M82.56,34.41l-.61.51c-1.15.93-2.29,1.84-3.43,2.78a.53.53,0,0,1-.8,0q-1.84-1.51-3.71-3c-.3-.24-.35-.38,0-.64,1.28-1,2.54-2.05,3.82-3.05a.61.61,0,0,1,.57,0c1.35,1.05,2.67,2.12,4,3.2A1.47,1.47,0,0,1,82.56,34.41Zm-8.46,0,4,3.25,4-3.25-4-3.24Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M20.51,64.61l-4-3.24,4-3.24,4,3.24Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M24.54,34.37l-3,2.39c-.35.28-.7.75-1.06.75s-.71-.46-1.05-.74c-.9-.71-1.78-1.43-2.67-2.15a3.21,3.21,0,0,1-.29-.27l4-3.22Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M45.29,34.37l4-3.25,4,3.25-4,3.25Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M78.12,58.12l4,3.25-4,3.25-4-3.25Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M54.14,61.37l-4,3.24-4-3.24,4-3.24Z"
              transform="translate(0 -22.36)"
            />
            <path
              class="cls-1"
              d="M74.1,34.37l4-3.24,4,3.24-4,3.25Z"
              transform="translate(0 -22.36)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
